/* Fuzance · La marque : plan des pistes.
   La ligne rouge se remplit au fil du défilement, le F descend la piste, les étapes s'allument.
   Élément personnalisé : il survit au rechargement de la section dans l'éditeur de thème. */
(function () {
  'use strict';
  if (customElements.get('fz-brand-story')) return;

  class FzBrandStory extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-step]'));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._tick = false;
      if (this.reduce) {
        this.style.setProperty('--p', '1');
        this.steps.forEach(function (s) { s.classList.add('is-on', 'is-seen'); });
        return;
      }
      var self = this;
      this._onScroll = function () {
        if (self._tick) return;
        self._tick = true;
        window.requestAnimationFrame(function () { self._tick = false; self.update(); });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      this.update();
    }

    disconnectedCallback() {
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }
      this._ready = false;
    }

    update() {
      var r = this.getBoundingClientRect(), vh = window.innerHeight, mid = vh * 0.55;
      var p = r.height > 0 ? (mid - r.top) / r.height : 0;
      p = Math.max(0, Math.min(1, p));
      this.style.setProperty('--p', p.toFixed(3));
      var cur = -1;
      this.steps.forEach(function (s, i) {
        var b = s.getBoundingClientRect();
        var on = b.top + 40 < mid;
        s.classList.toggle('is-on', on);
        if (on) cur = i;
        if (b.top < vh * 0.9) s.classList.add('is-seen');
      });
      this.steps.forEach(function (s, i) { s.classList.toggle('is-cur', i === cur); });
    }
  }

  customElements.define('fz-brand-story', FzBrandStory);
})();
